export default __webpack_public_path__ + "static/media/mobile.a4bb6ecf.jpg";